import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react'
import MainContainer from 'theme/MainConatiner'
import "./style.css";
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import CategoryCard from 'components/CategoryCard/CategoryCard';
import CategoryCardSkeleton from 'components/CategoryCard/CategoryCardSkeleton';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';

const FoodCategoriesContainer = ({
    categoryItem,
    setSearchQuery,
    searchTxt,
    handleAddBtn,
    loading,
    error,
    handleEdit,
    handleDelete,
    handleToggle,
    togglingCategoryId
}) => {
    const PLACEHOLDER_COUNT = 6;
    const hasData = !loading && categoryItem?.length > 0;
    const showNoItems = !loading && categoryItem?.length === 0;
    const itemsToRender = loading ? Array.from({ length: PLACEHOLDER_COUNT }) : categoryItem;
    const isSearching = searchTxt.trim().length > 0

    return (
        <MainContainer>
            <Card className='main-card-container'>
                <HeaderTilteBar
                    title={"Food Categories"}
                    isSearch={categoryItem?.length > 0 || isSearching}
                    btnText={"Add New"}
                    btnIcon={true}
                    onSearchChange={setSearchQuery}
                    searchQuery={searchTxt}
                    handleAddBtn={handleAddBtn}
                // handleBack={handleBack}
                />

                {showNoItems && (
                    <Box className='body-wrapper'>
                        {/* <NoItemsCreated
                            title="No Categories Created Yet!"
                            subtitle="Add your first food category to create your own menu."
                        /> */}
                        {isSearching ? (
                            <NoSearchFound
                                title="No Category matches your search"
                                subtitle={`Please try again with a different keyword to get result..`}
                            />
                        ) : (
                            <NoItemsCreated
                                title="No Categories Created Yet!"
                                subtitle="Add your first food category to create your own menu."
                            />
                        )}
                    </Box>
                )}

                {!showNoItems && (
                    <Box sx={{ mt: 1 }}>
                        <Grid container spacing={2}>
                            {itemsToRender?.map((cat, idx) => (
                                <Grid item xs={12} sm={6} md={4} key={cat?.id ?? idx}>
                                    {loading ? (
                                        <CategoryCardSkeleton />
                                    ) : (
                                        <CategoryCard
                                            title={cat.name}
                                            itemCount={cat?.itemsCount || 0}
                                            enabled={cat.active_status}
                                            onEdit={() => handleEdit(cat)}
                                            onDelete={() => handleDelete(cat)}
                                            onToggle={() => handleToggle(cat)}
                                            toggleDisabled={togglingCategoryId === cat.id}
                                        />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </Card>
        </MainContainer>
    )
}

export default FoodCategoriesContainer
